import { EmbeddedMessage } from 'constants/messageMediums';
import { selectUserProjectTimeZone } from 'core/userContext';
import { useCampaignContext } from 'modules/campaigns/editor/context';
import { BoldText } from 'modules/campaigns/editor/styles';
import { ScheduleFormState } from 'modules/campaigns/editor/types';
import { getSendSizeContent } from 'modules/campaigns/editor/utils';
import { useCampaignSendSize } from 'modules/campaigns/lib/hooks';
import momentTz from 'moment-timezone';
import { useSelector } from 'react-redux';
import { getStartTimeInEpochMs } from '../../ScheduleCampaignModal/ScheduleCampaignModal.utils';

export const ProjectTimeZoneScheduleDateSummary = ({ values }: { values: ScheduleFormState }) => {
  const { campaign, estimatedSendSizeData, expectedSendSizeData } = useCampaignContext();
  const { sendSize, isEstimated } = useCampaignSendSize({
    estimatedSendSizeData,
    expectedSendSizeData,
  });
  const projectTimeZone = useSelector(selectUserProjectTimeZone);
  const isEmbeddedCampaign = campaign.messageMedium === EmbeddedMessage;

  const { startDate, startTime } = values;

  const scheduleDateTimeInEpochMs = getStartTimeInEpochMs(startDate, startTime, projectTimeZone);
  const scheduleDateTime = momentTz(scheduleDateTimeInEpochMs).tz(projectTimeZone);
  const formattedScheduleDateTime = scheduleDateTime.format('dddd, MMMM Do YYYY [at] hh:mma z');

  return isEmbeddedCampaign ? (
    <>This campaign will be available for eligible users to see on {formattedScheduleDateTime}.</>
  ) : (
    <>
      This will send to <BoldText>{getSendSizeContent(sendSize, isEstimated)}</BoldText> on{' '}
      <BoldText>{formattedScheduleDateTime}</BoldText>{' '}
      {`(approximately ${scheduleDateTime.fromNow()})`}
    </>
  );
};
